import { Camera, CameraResultType, CameraSource } from '@capacitor/camera'
import {
    MainButton,
    MobileFrameDialog,
    TDialogStore,
    useDialogStore,
} from '@eventr/common-storybook'
import { Box } from '@mui/material'
import { FC } from 'react'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../i18n/i18next'
import { dataURLtoFile } from '../utils'

type TFilePickerDialog = {
    onFileSelected?: (file: File) => void
}

export const FilePickerDialog: FC<TFilePickerDialog> = ({ onFileSelected }) => {
    const { clearDialog }: TDialogStore = useDialogStore(
        useShallow((s: TDialogStore) => ({ clearDialog: s.clearDialog }))
    )

    return (
        <MobileFrameDialog>
            <Box
                display={'grid'}
                gap={'16px'}
                minWidth={'70vw'}
                padding={'16px'}
            >
                <MainButton
                    text={i18n.t('general.picture')}
                    icon="Document"
                    iconPosition="left"
                    onClick={() => {
                        try {
                            Camera.getPhoto({
                                source: CameraSource.Photos,
                                resultType: CameraResultType.DataUrl,
                                height: 700,
                            }).then((v) => {
                                const file = dataURLtoFile(
                                    v.dataUrl,
                                    'photo-' + Date.now() + '.jpg'
                                )

                                if (onFileSelected) onFileSelected(file)
                            })
                        } catch (e) {
                            console.log(e)
                        } finally {
                            clearDialog()
                        }
                    }}
                />

                <MainButton
                    text={i18n.t('general.camera')}
                    icon="Camera"
                    iconPosition="left"
                    onClick={() => {
                        try {
                            Camera.getPhoto({
                                source: CameraSource.Camera,
                                resultType: CameraResultType.DataUrl,
                                height: 700,
                            }).then((v) => {
                                const file = dataURLtoFile(
                                    v.dataUrl,
                                    'photo-' + Date.now() + '.jpg'
                                )
                                if (onFileSelected) onFileSelected(file)
                            })
                        } catch (e) {
                            console.log(e)
                        } finally {
                            clearDialog()
                        }
                    }}
                />

                <Box height={'32px'} />

                <MainButton
                    text={i18n.t('general.cancel')}
                    variant="destructiveGhost"
                    onClick={() => {
                        clearDialog()
                    }}
                />
            </Box>
        </MobileFrameDialog>
    )
}
